import { render } from "./OrgProfileGeneralInfo.vue?vue&type=template&id=23de75b8&scoped=true"
import script from "./OrgProfileGeneralInfo.vue?vue&type=script&lang=js"
export * from "./OrgProfileGeneralInfo.vue?vue&type=script&lang=js"

import "./OrgProfileGeneralInfo.vue?vue&type=style&index=0&id=23de75b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23de75b8"]])

export default __exports__